import {
  Box,
  Checkbox,
  Label,
  Radio,
  RadioGroup,
  Text,
} from "@salestrak/ui";
import { FULL_PERMISSIONS, PERMISSION_LABELS, type Permissions } from "./permission-badge";

interface PermissionEditProps {
  value: Permissions;
  onChange: (permissions: Permissions) => void;
}

export function PermissionEdit({ value, onChange }: PermissionEditProps) {
  const mode = value.all ? "full" : "selective";

  function handleModeChange(newMode: string) {
    if (newMode === "full") {
      onChange(FULL_PERMISSIONS);
    } else {
      onChange({ all: false, create: false, read: true, update: false, delete: false });
    }
  }

  function handlePermissionToggle(key: keyof Omit<Permissions, "all">) {
    onChange({ ...value, all: false, [key]: !value[key] });
  }

  return (
    <Box direction="column" gap="md">
      <Text size="sm" weight="medium">Permissions</Text>
      {/* Label wraps each control, so the text is both the accessible name and
        * the hit target. */}
      <RadioGroup
        value={mode}
        onValueChange={(next) => handleModeChange(String(next))}
      >
        <Label>
          <Radio value="full" />
          <Text size="sm" weight="normal">Full access</Text>
        </Label>
        <Label>
          <Radio value="selective" />
          <Text size="sm" weight="normal">Only select permissions</Text>
        </Label>
      </RadioGroup>

      {mode === "selective" && (
        <Box direction="column" gap="sm" paddingLeft="lg">
          {PERMISSION_LABELS.map((p) => (
            <Label key={p.key}>
              <Checkbox
                checked={value[p.key]}
                onCheckedChange={() => handlePermissionToggle(p.key)}
              />
              <Text size="sm" weight="normal">{`${p.label} — ${p.description}`}</Text>
            </Label>
          ))}
        </Box>
      )}
    </Box>
  );
}
